/*eslint-disable*/
import React, { Fragment, useState } from "react";

import classNames from "classnames";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";

import axios from 'axios';

import { makeStyles, useTheme } from "@material-ui/core/styles";

import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";

import {useFormik} from "formik";
import * as yup from 'yup';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";


import ContactStyle from 'pages/Contact/ContactStyle';
import {useMediaQuery} from "@material-ui/core";
import {BASE_URL, INQUIRE} from "../../constants/urls";
import ContactModal from "./ContactModal";

const CustomSkinMap = withScriptjs(
    withGoogleMap(() => (
        <GoogleMap
            defaultZoom={14}
            defaultCenter={{ lat: 35.167714, lng: 129.115439 }}
            defaultOptions={{
                scrollwheel: false,
                zoomControl: true,
                zoomControlOptions: {
                  position: google.maps.ControlPosition.RIGHT_CENTER,
                },
                fullscreenControl: false,
                streetViewControl: false,
                styles: [
                    {
                        featureType: "water",
                        stylers: [
                            { saturation: 43 },
                            { lightness: -11 },
                            { hue: "#0088ff" }
                        ]
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.fill",
                        stylers: [
                            { hue: "#ff0000" },
                            { saturation: -100 },
                            { lightness: 99 }
                        ]
                    },
                    {
                        featureType: "road",
                        elementType: "geometry.stroke",
                        stylers: [{ color: "#808080" }, { lightness: 54 }]
                    },
                    {
                        featureType: "landscape.man_made",
                        elementType: "geometry.fill",
                        stylers: [{ color: "#ece2d9" }]
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry.fill",
                        stylers: [{ color: "#ccdca1" }]
                    },
                    {
                        featureType: "road",
                        elementType: "labels.text.fill",
                        stylers: [{ color: "#767676" }]
                    },
                    {
                        featureType: "road",
                        elementType: "labels.text.stroke",
                        stylers: [{ color: "#ffffff" }]
                    },
                    { featureType: "poi", stylers: [{ visibility: "off" }] },
                    {
                        featureType: "landscape.natural",
                        elementType: "geometry.fill",
                        stylers: [{ visibility: "on" }, { color: "#b8cb93" }]
                    },
                    { featureType: "poi.park", stylers: [{ visibility: "on" }] },
                    {
                        featureType: "poi.sports_complex",
                        stylers: [{ visibility: "on" }]
                    },
                    { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
                    {
                        featureType: "poi.business",
                        stylers: [{ visibility: "simplified" }]
                    }
                ]
            }}
        >
            <Marker position={{ lat: 35.167714, lng: 129.115439 }} />
        </GoogleMap>
    ))
);

const useStyles = makeStyles(ContactStyle);

const instance = axios.create({
    baseURL: BASE_URL,
});

let modalContent = '';

const Contact = (props) => {
    const classes = useStyles();
    const theme = useTheme();

    const underSm = useMediaQuery(theme.breakpoints.down('sm'));
    const underXs = useMediaQuery(theme.breakpoints.down('xs'));

    const [showModal, setShowModal] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: '',
            phoneNumber: '',
            content: '',
        },
        validationSchema: yup.object().shape({
            name: yup.string().required('필수 입력 항목입니다.').max(32),
            phoneNumber: yup.string().required('필수 입력 항목입니다.').max(16, '올바른 번호를 입력해주세요.'),
            content: yup.string().required('필수 입력 항목입니다.').max(4000),
        }),
        onSubmit: (values, {setSubmitting, initialValues, resetForm}) => {
            const { name , phoneNumber, content } = values;
            instance.post(INQUIRE, {name, phone_number: phoneNumber, content}).then((res) => {
                setSubmitting(false);
                if (res.status >= 400) {
                    //modal
                    alert('알 수 없는 오류가 발생했습니다.')
                } else {
                    resetForm(initialValues);
                    alert('문의가 성공적으로 접수되었습니다.')
                }
                setShowModal(true);

            }).catch((err) => {
                setSubmitting(false);
                modalContent = '알 수 없는 오류로 제출에 실패했습니다.';
                setShowModal(true);
                alert('알 수 없는 오류가 발생했습니다.')
            });
        },
    });

    const {setFieldTouched, handleChange, handleSubmit, errors, touched, isSubmitting, values} = formik;

    return (
        <div style={{paddingBottom: 60}}>
            <div className={classes.bigMap}>
                <CustomSkinMap
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCx0hQlJ2vj4QrrtZOL2EYMQs2jQAlMUis"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={
                        <div
                            style={{
                                height: `100%`,
                                borderRadius: "6px",
                                overflow: "hidden"
                            }}
                        />
                    }
                    mapElement={<div style={{ height: `100%` }} />}
                />
                <div style={{
                    position: 'absolute', width: '100%', height: 80, bottom: 0, left: 0,
                    backgroundImage: 'linear-gradient(rgba(238, 238, 238, 0), rgba(238, 238, 238, 1))'
                }}/>
            </div>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.contactContent}>
                    <div className={classes.container}>
                        <GridContainer>
                            {
                                !underSm &&
                                <GridItem md={4} sm={12} xs={12}>
                                    <h2 className={classes.title}> </h2>
                                    <InfoArea
                                        className={classes.info}
                                        title="찾아오시는 길"
                                        description={
                                            <p>
                                                부산광역시 수영구 수영로 759<br /> 이룸비지니스센터 504호
                                            </p>
                                        }
                                        icon={PinDrop}
                                        iconColor="danger"
                                    />
                                    <InfoArea
                                        className={classes.info}
                                        title="문의 전화"
                                        description={
                                            <p>
                                                (+82) 010 - 7536 - 2403 <br /> 언제든지 연락주세요
                                            </p>
                                        }
                                        icon={Phone}
                                        iconColor="danger"
                                    />
                                </GridItem>
                            }
                            <GridItem md={6} sm={12} xs={12} className={classes.mlAuto}>
                                <h2 className={classes.title} style={{fontSize: underXs ? '1.8rem' : null}}>차량 등록/대여 문의하기</h2>
                                <p>
                                    <ul>
                                        <li>고령층 차주 회원 : 차량 관련 정보, 가입비, 차량 점검 접수</li>
                                        <li>이용자 회원 : 운전면허증, 신용카드</li>
                                        <li>얼라이언스 기업 회원: 업종, 서비스 지역, 가입비 결제</li>
                                        <li>광고:  업종, 광고 단가 안내, 광고 일시, 광고비 결제</li>
                                        <li>제안 및 제휴</li>
                                    </ul>
                                </p>
                                <form>
                                    <CustomInput
                                        labelText="성함/업체명"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        maxLength={32}
                                        inputProps={{
                                            onChange: handleChange('name'),
                                            onBlur: ()=>setFieldTouched('name'),
                                            disabled: isSubmitting,
                                            placeholder: errors.name,
                                            value: values.name,
                                        }}
                                        error={errors.name && touched.name}
                                    />
                                    <CustomInput
                                        labelText="전화번호"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        maxLength={16}
                                        inputProps={{
                                            onChange: handleChange('phoneNumber'),
                                            onBlur: ()=>setFieldTouched('phoneNumber'),
                                            disabled: isSubmitting,
                                            placeholder: errors.phoneNumber,
                                            value: values.phoneNumber,
                                        }}
                                        error={errors.phoneNumber && touched.phoneNumber}
                                    />
                                    <CustomInput
                                        labelText="문의 내용"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        maxLength={4000}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            onChange: handleChange('content'),
                                            onBlur: ()=>setFieldTouched('content'),
                                            disabled: isSubmitting,
                                            placeholder: errors.content,
                                            value: values.content
                                        }}
                                        error={errors.content && touched.content}
                                    />
                                    <div className={classes.textCenter}>
                                        <Button
                                            color="danger"
                                            disabled={!!Object.keys(errors).length || isSubmitting || !values.phoneNumber}
                                            onClick={handleSubmit} >
                                            문의하기
                                        </Button>
                                    </div>
                                </form>
                                {/*<ContactModal isOpen={showModal} close={() => setShowModal(false)} content={modalContent} />*/}
                            </GridItem>
                            {
                                !!underSm &&
                                <Fragment>
                                    <GridItem md={12} sm={6} xs={12}>
                                        <InfoArea
                                            className={classes.info}
                                            title="찾아오시는 길"
                                            description={
                                                <p>
                                                    부산광역시 수영구 수영로 759<br /> 이룸비지니스센터 504호
                                                </p>
                                            }
                                            icon={PinDrop}
                                            iconColor="danger"
                                        />
                                    </GridItem>
                                    <GridItem md={12} sm={6} xs={12}>
                                        <InfoArea
                                            className={classes.info}
                                            title="문의 전화"
                                            description={
                                                <p>
                                                    (+82) 010 - 7536 - 2403 <br /> 언제든지 연락주세요
                                                </p>
                                            }
                                            icon={Phone}
                                            iconColor="danger"
                                        />
                                    </GridItem>
                                </Fragment>
                            }
                        </GridContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Contact;
